import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "./App"
import MaintenancePage from './MaintenancePage';

import "./index.css"

import * as Sentry from "@sentry/react";

const maintenanceMode = false;

if (import.meta.env.MODE === "production") {
  Sentry.init({ 
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Don't report requests the user abandoned (page change / tab closed) or expired logins
    ignoreErrors: [
      /^Request aborted$/,
      /^canceled$/,
      /^Request failed with status code 401$/,
    ],
    // Keep 10% of network errors, so a real API outage still shows up as a spike
    beforeSend(event, hint) {
      if (hint?.originalException?.message === "Network Error" && Math.random() > 0.1) {
        return null;
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    {maintenanceMode ? <MaintenancePage /> : <App />}
  </StrictMode>
)
